module.exports = __webpack_public_path__ + "img/TCascade.af880c14.png";